'use strict';
var focusHelper = require('base/components/focus');
var carousels = require('../components/carousels');
var shopSimilarStyles = require('../components/shopSimilarStyles');
var fyl = require('../components/fyl');
var clientSideValidation = require('../components/clientSideValidation');
var quantitySelect = require('../components/quantitySelect');

const sizeTooltipOptions = {
    container: '.product-detail:not(.modal-body)',
    offset: '0, 20px',
    template: '<div class="tooltip swatch-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
};
/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {jquery} elem - DOM container for a given add to cart button
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl(elem) {
    return elem.closest('.product-detail').find('.add-to-cart-url').val();
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $($el).closest('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $($el).closest('.product-detail').find('.quantity .input-text.quantity.quantity-input');
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Update customer's subscribed alerts
 *
 * @param {Object} product - product to parse
 * @param {string} size - size to use
 * @return {string} - the SKU
 */
function fetchSKU(product, size = null) {
    let skuBits = [];
    skuBits.push(product.masterID);
    skuBits.push(product.selectedColor || '');
    skuBits.push(size || product.selectedSize || '');
    return skuBits.join('-').toLowerCase();
}

/**
 * Retrieve items already subscribed by customer
 * @return {Array} - list of alerts already subscribed
 */
function retrieveBISAlerts() {
    let alerts = [];
    try {
        alerts = JSON.parse(localStorage.getItem('BISItems')) || [];
    } catch (err) {
        alerts = [];
    }
    return alerts;
}

/**
 * Update customer's subscribed alerts
 *
 * @param {Object} sku - sku to store
 */
function updateBISAlerts(sku) {
    const currentItems = retrieveBISAlerts();
    try {
        currentItems.push(sku.toLowerCase());
        localStorage.setItem('BISItems', JSON.stringify(currentItems));
    } catch (e) {
        // do nothing
    }
}

/**
 * Update customer's subscribed alerts
 *
 * @param {Object} scope - useful context to retrieve important things
 */
function handleBISTooltip(scope) {
    const klaviyoEnabled = $('#alertBackInStock').data('klaviyo-enabled');
    const hiddenBISButton = $('.backInStockAlert .alert-back-in-stock');
    const bisTooltipOptions = {
        container: '.product-detail:not(.modal-body)',
        offset: '0, 20px',
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    };
    if (!klaviyoEnabled) {
        return;
    }
    scope.tooltip('dispose');
    if (scope.is('.selected')) {
        scope.data('no-tooltip', true).attr('data-tooltip-html', true).off();
        return;
    }
    const sizeButton = scope.clone().removeAttr('data-toggle title data-original-title').attr('data-tooltip-html', true);
    const product = $('#alertBackInStock').data('product');
    const sku = fetchSKU(product, scope.data('attr-value').toString().toLowerCase());
    const subscribedItems = retrieveBISAlerts();
    if (subscribedItems.includes(sku)) {
        sizeButton
            .off()
            .tooltip('dispose')
            .removeAttr('data-tooltip-html')
            .tooltip($.extend({}, bisTooltipOptions, {
                title: $('<div />').append($('.backInStockAlert .state-3 span:nth-child(2)').text()),
                html: true
            }));
        scope.replaceWith(sizeButton);
        return;
    }

    let tooltipTimer = null;
    const tooltipContent = $('<div />').append(
        $('<p />').addClass('m-0').text(scope.closest('.sizes-container').data('tooltip-title'))
    ).append(
        $('<button/>')
            .data('size', scope.data('attr-value'))
            .data('success-title', hiddenBISButton.data('success-title'))
            .data('success-subtitle', hiddenBISButton.data('success-subtitle'))
            .data('error-message', hiddenBISButton.data('error-message'))
            .attr('data-toggle', 'modal')
            .attr('data-target', '#alertBackInStock')
            .addClass('btn btn-link btn-block btn-sm text-left alert-back-in-stock')
            .append($('<u />').text(scope.closest('.sizes-container').data('tooltip-button')))
    );
    scope.replaceWith(sizeButton);
    const tooltipOptions = $.extend({}, bisTooltipOptions, {
        title: tooltipContent,
        trigger: 'manual',
        html: true
    });
    sizeButton.tooltip(tooltipOptions).on('click', () => {
        if (!sizeButton.is('.selected')) {
            clearTimeout(tooltipTimer);
            tooltipTimer = null;
            sizeButton.tooltip('dispose');
        }
    }).on('mouseenter', () => {
        clearTimeout(tooltipTimer);
        tooltipTimer = null;
        sizeButton.tooltip('show');
    }).on('mouseleave', () => {
        if (tooltipTimer) return;
        tooltipTimer = setTimeout(() => sizeButton.tooltip('hide'), 200);
    })
        .on('inserted.bs.tooltip', () => {
            const tip = sizeButton.data('bs.tooltip').tip;
            $(tip).one('mouseenter', () => {
                clearTimeout(tooltipTimer);
                tooltipTimer = null;
            }).one('mouseleave', () => {
                if (tooltipTimer) return;
                tooltipTimer = setTimeout(() => sizeButton.tooltip('hide'), 200);
            }).find('.tooltip-inner')
                .css('max-width', 'max-content');
        });
}

/**
 * Process the attribute values for an attribute that is not a default HTML select element
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
        var $specialSelectToggle = $productContainer.find('.special-select-toggle');

        $attrValue.each(function () {
            var $this = $(this);
            var isDropdownItem = $this.hasClass('js-dropdown-color');// Handling the special dropdown selector on QV
            var $swatchButton = isDropdownItem ? $this : $this.parent();

            if (attrValue.selected) {
                $this.addClass('selected');
                $this.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);

                if (isDropdownItem) {
                    $specialSelectToggle.addClass('selected').html($this.html());
                }
            } else {
                $this.removeClass('selected');
                $this.siblings('.selected-assistive-text').empty();
            }

            if (attrValue.url) {
                $swatchButton.attr('data-url', attrValue.url);
            } else {
                $swatchButton.removeAttr('data-url');
            }

            // Disabled state handling
            if (isDropdownItem) {
                $this.toggleClass('disabled', !attrValue.selectable);
            } else {
                $this.removeClass('selectable unselectable').addClass(attrValue.selectable ? 'selectable' : 'unselectable');
            }

            // Handle the SIZE tooltip message change
            if (attr.id === 'size') {
                var selectableTitle = attrValue.stockMessage || '';
                var unselectableTitle = attrValue.noStockMessage || '';

                if (String(selectableTitle).toLowerCase() === 'null' || String(selectableTitle).toLowerCase() === 'undefined') {
                    selectableTitle = '';
                }
                if (String(unselectableTitle).toLowerCase() === 'null' || String(unselectableTitle).toLowerCase() === 'undefined') {
                    unselectableTitle = '';
                }
                var title = attrValue.selectable ? selectableTitle : unselectableTitle;
                $this.attr('data-selectable-title', selectableTitle);
                $this.attr('data-unselectable-title', unselectableTitle);
                if ((!attrValue && $this.attr('data-tooltip-html')) || attrValue.tooltipHtml) {
                    handleBISTooltip($this);
                }

                if ($this.length && !$this.data('no-tooltip') && title) {
                    $this.tooltip('dispose');
                    $this.attr('data-original-title', title).tooltip($.extend({}, sizeTooltipOptions, { title: title }));
                } else if ($this.length) {
                    $this.tooltip('dispose');
                    $this.removeData('originalTitle title');
                    $this.removeAttr('data-original-title title aria-describedby');
                }
            }
        });

        // If the color on the dropdown was de-selected, restore the default text
        if ($specialSelectToggle.length > 0 && $productContainer.find('.js-dropdown-color.selected').length < 1) {
            $specialSelectToggle.removeClass('selected').find('.special-select-item').html(`<span class="color-name">${$specialSelectToggle.data('select-text')}</span>`);
        }
    });

    if (attr.id === 'size') {
        $productContainer.find('.selected-size').text(attr.displayValue);
    }
}

/**
 * Process attribute values associated with an attribute that uses a default HTML select element
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }

        $attrValue.prop('selected', attrValue.selected);
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has buttons or a select element, or both
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    attrs.forEach(function (attr) {
        var $this = $(`[data-attr="${attr.id}"]`);

        if ($this.find(`select.select-${attr.id}`).length > 0) {
            processNonSwatchValues(attr, $productContainer);
        }

        // special-select-toggle is the special select with swatch colors inside, used on QV.
        if ($this.find(`button.${attr.id}-attribute`).length > 0 || $this.find('button.special-select-toggle').length > 0) {
            processSwatchValues(attr, $productContainer, msgs);
        }
    });
}

/**
 * @function
 * @description Binds events to the select elements of the bonus product functionality
 * @param {Object} $productContainer - the current context
 * @param {Object} data - an Object representing the JSON data from the server
 */
function handleColorChange({ attributeType, container: $productContainer, data }) {
    if (attributeType === 'size') {
        return;
    }
    const product = data.product;
    const sizeAttribute = product.variationAttributes.find(attr => attr.attributeId === 'size');
    if (!sizeAttribute) return;

    sizeAttribute.values.forEach((sizeValue) => {
        var $attrValue = $productContainer.find('[data-attr="size"] [data-attr-value="' + sizeValue.value + '"]');
        let pidReplaced = false;
        $attrValue.each(function () {
            const $this = $(this);
            if (sizeValue.selected && !sizeValue.selectable) {
                sizeValue.selected = false;
            }
            if (!sizeValue.selectable && $this.hasClass('selected')) {
                if (!pidReplaced) {
                    const styleId = $('.product-detail:not(".bundle-item")').data('pid').split('-')[0];
                    $('.product-detail:not(".bundle-item")').data('pid', styleId);
                    pidReplaced = true;
                }
                $this.removeClass('selected');
                if ($('.backInStockAlert .state-2').is(':visible')) {
                    $('.backInStockAlert .state-2').hide();
                    $('.backInStockAlert .state-1').show();
                }
            }
        });
    });

    if (product.variationAttributes) {
        updateAttrs(product.variationAttributes, $productContainer, {});
    }
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    var $sizeAttr = $productContainer.find('[data-attr="size"]');
    var $colorAttr = $productContainer.find('[data-attr="color"]');
    var isSizeSelected = $sizeAttr.length === 0 || $sizeAttr.find('.selected').length > 0;
    var isColorSelected = $colorAttr.length === 0 || $colorAttr.find('.selected').length > 0;
    var isVariantSelected = isSizeSelected && isColorSelected;

    if (!isVariantSelected) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Updates the quantity for edit cart and quick view
 *
 * @param {Object} product - Product object
 * @param {Object} modal - Modal for quantity update
 */
function updateQuantityValues(product, modal) {
    modal.find('.quantity-module .invalid-feedback').removeClass('d-block').empty();
    modal.find('.quantity-select').attr('max', product.maxOrderQuantity);
    modal.find('.quantity-input').attr('max', product.maxOrderQuantity);
    modal.find('.quantity-select').val(product.selectedQuantity);
    modal.find('.quantity-input').val(product.selectedQuantity);
    modal.find('.quantity-select').attr('value', product.selectedQuantity);
    modal.find('.quantity-input').attr('value', product.selectedQuantity);
    modal.find('.update-cart-url').data('selected-quantity', modal.find('.quantity-select').val());
    modal.find('.quantity-decrease, .quantity-increase').removeClass('disabled').removeAttr('disabled');

    // disable minus buttons if needed
    if (product.selectedQuantity === product.minOrderQuantity) {
        modal.find('.quantity-decrease').addClass('disabled').attr('disabled', 'disabled');
    }

    // disable plus buttons if needed
    if (product.selectedQuantity === product.maxOrderQuantity) {
        modal.find('.quantity-increase').addClass('disabled').attr('disabled', 'disabled');
    }
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * @param {Object} product - SFRA product model
 * @returns {boolean} true when product has a color variation attribute
 */
function productHasColorVariation(product) {
    if (!product || !product.variationAttributes || !product.variationAttributes.length) {
        return false;
    }

    return product.variationAttributes.some(function (attribute) {
        return attribute.id === 'color';
    });
}

/**
 * @param {string} attributeType - attribute that triggered variation refresh
 * @param {Object} product - SFRA product model
 * @returns {boolean} true when recommended alternatives should refresh
 */
function shouldRefreshRecommendedAlternatives(attributeType, product) {
    if (!productHasColorVariation(product)) {
        return false;
    }

    return attributeType === 'color';
}

/**
 * Replace and initialize recommended alternatives carousel after variation response
 * @param {Object} data - variation ajax response
 * @param {jQuery} $productContainer - PDP container
 * @param {string} attributeType - attribute that triggered variation refresh
 */
function updateRecommendedAlternativesCarousel(data, $productContainer, attributeType) {
    if (!data || !shouldRefreshRecommendedAlternatives(attributeType, data.product)) {
        return;
    }

    if ($productContainer.closest('#quickViewModal').length > 0) {
        return;
    }

    var $container = $productContainer.find('#shop-similar-styles-container');
    if (!$container.length) {
        $container = $('#shop-similar-styles-container');
    }

    if (!$container.length) {
        return;
    }

    $container.html(data.shopSimilarStylesHtml || '');

    if (data.shopSimilarStylesHtml) {
        shopSimilarStyles.init();
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }

        // Handle the Selected Price above the SIZE selectors
        $productContainer.find('.selected-price-container').toggleClass('d-flex', response.product.readyToOrder);

        if (isVaraint && response.product.readyToOrder) {
            if (response.product.pdpVariantPrice && response.product.pdpVariantPrice.sales && response.product.pdpVariantPrice.sales.formatted !== 'N/A') {
                $productContainer.find('.selected-price').text(response.product.pdpVariantPrice.sales.formatted);
            } else {
                $productContainer.find('.selected-price').text(response.product.price.sales.formatted);
            }

            if (response.product.isSkuOnSaleOrClearance) {
                $productContainer.find('.selected-price').addClass('sale');
            } else {
                $productContainer.find('.selected-price').removeClass('sale');
            }
        }
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        if (response.product.pdpVariantPrice && response.product.pdpVariantPrice.sales && response.product.pdpVariantPrice.sales.value === 0 && response.product.pdpVariantPrice.sales.formatted === 'N/A') {
            $priceSelector.replaceWith(response.product.price.html);
        } else if (response.product.pdpVariantPrice && response.product.pdpVariantPrice.html) {
            $priceSelector.replaceWith(response.product.pdpVariantPrice.html);
        } else {
            $priceSelector.replaceWith(response.product.price.html);
        }
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    if ($('.product-quickview').length > 0) {
        var $quickviewModal = $('.product-quickview');
        updateQuantityValues(response.product, $quickviewModal);
    } else if ($('.product-details-column').length > 0) {
        var $productModal = $('.product-details-column');
        updateQuantityValues(response.product, $productModal);
    }
    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
 * Apply sku pricing rule when a variant is selected
 * @param {Object} response - response from Ajax call
 */
function applyNewPriceDisplay(response) { // eslint-disable-line
    $('.size-extra-price').addClass('d-none');
    var $priceContainer = $('.product-price-ratings');
    var labelSale = $priceContainer.data('priceLabelSale') || 'Sale price';
    var labelOriginal = $priceContainer.data('priceLabelOriginal') || 'Original price';
    var priceHtml;
    var salesPriceFormatted;
    var salesPriceValue;
    var listPriceFormatted;
    var listPriceValue;
    var showStrikeThroughPrice = false;
    var salesOriginalPriceAttr = '';
    var listOriginalPriceAttr = '';
    var productPriceExist = response && response.product && response.product.price;
    var listPriceExist = productPriceExist && response.product.price.list && response.product.price.list.formatted !== 'N/A';
    var salesPriceExist = productPriceExist && response.product.price.sales && response.product.price.sales.formatted !== 'N/A';
    if (salesPriceExist) {
        salesPriceFormatted = response.product.price.sales.formatted;
        salesPriceValue = response.product.price.sales.value;
        var salesOriginalPrice = response.product.price.sales.originalPrice;
        salesOriginalPriceAttr = salesOriginalPrice ? ` data-original-price='${salesOriginalPrice}'` : '';
    }
    if (listPriceExist) {
        listPriceFormatted = response.product.price.list.formatted;
        listPriceValue = response.product.price.list.value;
        var listOriginalPrice = response.product.price.list.originalPrice;
        listOriginalPriceAttr = listOriginalPrice ? ` data-original-price='${listOriginalPrice}'` : '';
    }
    var regularPrice = response.product.regularPriceObject;
    if (response.product.isSkuOnSale && salesPriceValue && listPriceValue && (salesPriceValue < listPriceValue)) {
        showStrikeThroughPrice = true;
    }
    if (response.product.isSkuOnClearance && salesPriceValue && regularPrice && regularPrice.formatted !== 'N/A' && (salesPriceValue < regularPrice.value)) {
        listPriceFormatted = regularPrice.formatted;
        listPriceValue = regularPrice.value;
        showStrikeThroughPrice = true;
    }
    var salesValueAttributes = '';
    if (response.product.isSkuOnSaleOrClearance && salesPriceValue && regularPrice && regularPrice.formatted !== 'N/A' && (salesPriceValue < regularPrice.value)) {
        salesValueAttributes = ' content="' + salesPriceValue + '"' + salesOriginalPriceAttr;
        priceHtml = `
            <div class="price">
                <span class="sales sale">
                    <span class="sr-only">` + labelSale + `</span>
                    <span class="value"` + salesValueAttributes + `>
                        ` + salesPriceFormatted + `
                    </span>
                </span>`;
        if (showStrikeThroughPrice) {
            var listValueAttributes = ' content="' + listPriceValue + '"' + listOriginalPriceAttr;
            priceHtml +=
                `<span class="strike-through list">
                <span class="sr-only">` + labelOriginal + `</span>
                <span class="value"` + listValueAttributes + `>
                    ` + listPriceFormatted + `
                </span>
            </span>`;
        }
        priceHtml +=
            '</div>';
    } else {
        salesValueAttributes = ' content="' + salesPriceValue + '"' + salesOriginalPriceAttr;

        priceHtml = `
            <div class="price">
                <span class="list">
                    <span class="sr-only">` + labelOriginal + `</span>
                    <span class="value"` + salesValueAttributes + `>
                        ` + salesPriceFormatted + `
                    </span>
                </span>
            </div>
        `;
    }
    $('.sku-price-display').empty().append(priceHtml);
    $('.master-price-display').addClass('d-none');
    $('.sku-price-display').removeClass('d-none');
}

/**
 * Apply sku pricing rule when MASTER is selected
 * @param {Object} response - response from Ajax call
 */
function applyMasterPriceDisplay(response) { // eslint-disable-line
    const product = response && response.product;
    const colorAttrArray = ['classicArray', 'clearanceArray', 'limitedArray', 'otherArray', 'saleArray'];
    const colorAttribute = product.variationAttributes.find(attr => attr.attributeId === 'color');
    var $priceContainer = $('.product-price-ratings');
    var labelSaleFrom = $priceContainer.data('priceLabelSaleFrom') || 'Sale price from';
    var labelFrom = $priceContainer.data('priceLabelFrom') || 'Price from';
    var labelOriginal = $priceContainer.data('priceLabelOriginal') || 'Original price';

    if (product.price.type === 'tiered' || !colorAttribute) {
        $('.master-price-display').removeClass('d-none');
        $('.size-extra-price').removeClass('d-none');
        $('.sku-price-display').addClass('d-none');
        return;
    }

    var priceHtml;
    var isOnSale = false;
    var showStrikeThroughPrice = false;
    var regularPrice = product && product.regularPriceObject;
    var regularPriceFormatted = product && product.regularPriceFormatted;
    var variationMinPrice;
    var variationMaxPrice;
    var variationMinOriginalPrice;
    var variationMaxOriginalPrice;

    for (let i = 0; i < colorAttrArray.length; i++) {
        var arrayName = colorAttrArray[i];

        for (let j = 0; j < colorAttribute[arrayName].length; j++) {
            var color = colorAttribute[arrayName][j];

            if (color.selected) {
                isOnSale = (colorAttrArray[i] === 'clearanceArray' || colorAttrArray[i] === 'saleArray');
                if (color.priceFormatted) {
                    variationMinPrice = color.priceFormatted;
                    variationMaxPrice = color.priceFormatted;
                    variationMinOriginalPrice = color.priceOriginal;
                    variationMaxOriginalPrice = color.priceOriginal;
                } else {
                    var range = colorAttribute[colorAttrArray[i].replace('Array', 'Range')];
                    variationMinPrice = range.minPrice;
                    variationMaxPrice = range.maxPrice;
                    variationMinOriginalPrice = range.minOriginalPrice;
                    variationMaxOriginalPrice = range.maxOriginalPrice;
                }
                break;
            }
        }

        if (variationMinPrice && variationMaxPrice) {
            showStrikeThroughPrice = Number(variationMaxPrice.replace(/[^0-9.-]+/g, '')) < Number(regularPriceFormatted.replace(/[^0-9.-]+/g, ''));
            break;
        }
    }

    var minOriginalPriceAttr = variationMinOriginalPrice ? ` data-original-price='${variationMinOriginalPrice}'` : '';
    var maxOriginalPriceAttr = variationMaxOriginalPrice ? ` data-original-price='${variationMaxOriginalPrice}'` : '';
    var minValueAttributes = ' content="' + variationMinPrice + '"' + minOriginalPriceAttr;
    priceHtml = `
        <div class="price">
            <span class="price-main">
                <span class="text-nowrap sales` + (isOnSale ? ' sale' : '') + `">
                    <span class="sr-only">` + (isOnSale ? labelSaleFrom : labelFrom) + `</span>
                    <span class="value"` + minValueAttributes + `>
                        ` + variationMinPrice + `
                    </span>`;
    if (Number(variationMinPrice.replace(/[^0-9.-]+/g, '')) < Number(variationMaxPrice.replace(/[^0-9.-]+/g, ''))) {
        var maxValueAttributes = ' content="' + variationMaxPrice + '"' + maxOriginalPriceAttr;
        priceHtml += ' - <span class="value"' + maxValueAttributes + '>' + variationMaxPrice + '</span>';
    }
    priceHtml += `</span>
            </span>`;
    if (showStrikeThroughPrice) {
        var regularOriginalPrice = regularPrice && regularPrice.originalPrice;
        var regularOriginalPriceAttr = regularOriginalPrice ? ` data-original-price='${regularOriginalPrice}'` : '';
        var regularValueAttributes = ' content="' + regularPriceFormatted + '"' + regularOriginalPriceAttr;
        priceHtml +=
            `<span class="strike-through list">
                <span class="sr-only">` + labelOriginal + `</span>
                <span class="value"` + regularValueAttributes + `>
                    ` + regularPriceFormatted + `
                </span>
            </span>`;
    }
    priceHtml +=
        '</div>';

    $('.master-price-display').empty().append(priceHtml);
    $('.master-price-display').removeClass('d-none');
    $('.size-extra-price').removeClass('d-none');
    $('.sku-price-display').addClass('d-none');
}

/**
 * Shows an overlay mask to prevent user interactions.
 */
function showOverlay() {
    $('<div id="overlay"></div>').addClass('overlay').appendTo('body');
}

/**
 * Hides the overlay mask.
 */
function hideOverlay() {
    $('#overlay').remove();
}

/**
 * Returns the size attribute section within a product detail container
 * @param {jQuery} $productDetail - product detail container
 * @returns {jQuery} size section wrapper
 */
function getSizeSection($productDetail) {
    return $productDetail.find('[data-attr="size"]').first();
}

/**
 * Clears PDP size validation feedback
 * @param {jQuery} $productDetail - product detail container
 */
function clearPdpSizeValidationError($productDetail) {
    var $sizeSection = getSizeSection($productDetail);
    if (!$sizeSection.length) {
        return;
    }
    $sizeSection.find('.js-pdp-size-validation-message').empty();
    $sizeSection.find('.js-pdp-size-apply-status').empty();
    $sizeSection.find('.sizes-container').removeClass('is-invalid').removeAttr('aria-invalid');
    $sizeSection.find('button.size-attribute').removeAttr('aria-invalid');
    $productDetail.find('.error-tip').empty().addClass('d-none');
    $productDetail.find('.size-value.selectable').removeClass('unselected');
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} attributeType - Attribute type that originated the call
 * @param {string} Qty - Quantity from modal
 */
function attributeSelect(selectedValueUrl, $productContainer, attributeType, Qty) {
    if (selectedValueUrl) {
        let params = selectedValueUrl.split('?')[1];
        var qty = Qty || $productContainer.find('.quantity-input').attr('value');

        // Replace quantity value in URL
        if (params && qty !== undefined) {
            let paramList = params.split('&');
            let qtyDefinition = paramList.find(paramDefinition => ~paramDefinition.indexOf('quantity'));

            if (qtyDefinition) {
                selectedValueUrl = selectedValueUrl.replace(qtyDefinition, `quantity=${qty}`); // eslint-disable-line
            }
        }

        if ($productContainer.closest('#quickViewModal').length > 0) {
            selectedValueUrl += (selectedValueUrl.indexOf('?') !== -1 ? '&' : '?') + 'source=quickview'; // eslint-disable-line
        }

        showOverlay();

        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                if (data.product.availability.messagesTypes[0] === 'backOrder') {
                    $('.paypal-paylater-messaging').addClass('d-none');
                } else {
                    $('.paypal-paylater-messaging').removeClass('d-none');
                }
                $('body').trigger('product:afterAttributeSelectInit', { data: data });
                handleVariantResponse(data, $productContainer);
                updateRecommendedAlternativesCarousel(data, $productContainer, attributeType);
                updateOptions(data.product.optionsHtml, $productContainer);

                $('body').trigger('product:afterAttributeSelect', {
                    data: data,
                    container: $productContainer,
                    attributeType: attributeType || null
                });
                handleColorChange({ attributeType, container: $productContainer, data });
                if ($('.restricted-hover').length > 0) {
                    if (data.product && data.product.availability.messagesTypes[0] === 'restriction') {
                        $('.restricted-hover').removeClass('d-none');
                    } else {
                        $('.restricted-hover').addClass('d-none');
                    }
                }
                clearPdpSizeValidationError($productContainer);
                if (data.product.productType === 'variant') {
                    applyNewPriceDisplay(data, $productContainer);
                } else {
                    applyMasterPriceDisplay(data, $productContainer);
                }
                if ((data.product.isSkuOnClearance === true || data.product.isSkuOnSale === true) && $productContainer.hasClass('product-quickview')) {
                    $productContainer.find('.price-main').addClass('sale');
                }
                $.spinner().stop();
                $('.color-attribute').spinner().stop();
                $('.size-attribute').spinner().stop();
                hideOverlay();
            },
            error: function () {
                $.spinner().stop();
                hideOverlay();
            }
        });
    }
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog modal--added-by-js" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Returns the product detail container for size validation (Quick View modal vs PDP)
 * @param {jQuery} [$context] - optional DOM context to resolve closest product detail
 * @returns {jQuery} product detail container
 */
function getSizeValidationProductDetail($context) {
    var $quickView = $('#quickViewModal.show .product-detail');
    if ($quickView.length) {
        return $quickView.first();
    }
    if ($context && $context.length) {
        var $closest = $context.closest('.product-detail');
        if ($closest.length) {
            return $closest.first();
        }
    }
    var $pdp = $('#pdpProductDetails');
    if ($pdp.length) {
        return $pdp;
    }
    return $('.product-detail').first();
}

/**
 * Determines whether an add-to-cart error is due to a missing size selection
 * @param {string} message - error message from server
 * @param {jQuery} $productDetail - product detail container
 * @returns {boolean} whether message is size selection error
 */
function isSizeSelectionError(message, $productDetail) {
    var $sizesContainer = getSizeSection($productDetail).find('.sizes-container');
    if (!$sizesContainer.length) {
        return false;
    }
    var expectedMessage = $sizesContainer.data('msg-size-required');
    return Boolean(expectedMessage && message === expectedMessage);
}

/**
 * Announces size validation via live region, then moves focus to first selectable size
 * @param {jQuery} $applyStatus - live region element
 * @param {string} message - screen reader message
 * @param {jQuery} $firstSelectable - first selectable size button
 * @param {number} focusDelayMs - delay before focus after live region update
 */
function announceSizeValidationAndFocus($applyStatus, message, $firstSelectable, focusDelayMs) {
    $applyStatus.empty();
    window.setTimeout(function () {
        $applyStatus.text(message);
        window.setTimeout(function () {
            if ($firstSelectable.length) {
                $firstSelectable.focus();
            }
        }, focusDelayMs);
    }, 100);
}

/**
 * Shows PDP size validation feedback after add to cart failure
 * @param {jQuery} $productDetail - product detail container
 * @param {string} message - primary error message from server
 * @param {boolean} scrollToSize - whether to scroll to size section
 */
function showPdpSizeValidationError($productDetail, message, scrollToSize) {
    var $sizeSection = getSizeSection($productDetail);
    var $sizesContainer = $sizeSection.find('.sizes-container');
    var $validationMessage = $sizeSection.find('.js-pdp-size-validation-message');
    var $applyStatus = $sizeSection.find('.js-pdp-size-apply-status');
    var secondaryMessage = $sizesContainer.data('msg-make-selection') || '';

    $productDetail.find('.error-tip').removeClass('d-none').empty().append(message);
    $productDetail.find('.size-value.selectable').addClass('unselected');

    var $firstSelectable = $sizeSection.find('button.size-attribute').filter(function () {
        return $(this).find('.size-value.selectable').length > 0;
    }).first();

    $sizesContainer.addClass('is-invalid').attr('aria-invalid', 'true');
    $validationMessage.text(secondaryMessage);
    $applyStatus.empty();

    $sizeSection.find('button.size-attribute').removeAttr('aria-invalid');
    if ($firstSelectable.length) {
        $firstSelectable.attr('aria-invalid', 'true');
    }

    if (scrollToSize) {
        $('.is-sticky .add-to-cart').blur();
        var stickyOffset = ($('.is-stuck').outerHeight() || 0) + 100;
        $('html, body').animate({
            scrollTop: $sizeSection.find('span.size').offset().top - stickyOffset
        }, 500, function () {
            // Defer SR announcement until scroll settles — VoiceOver/iOS suppresses
            // live regions during scroll, so the early t=100ms update is never heard.
            announceSizeValidationAndFocus($applyStatus, message, $firstSelectable, 150);
        });
    } else {
        announceSizeValidationAndFocus($applyStatus, message, $firstSelectable, 0);
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {jQuery} $this - DOM element for add to cart button clicked
 * @param {boolean} isQuickView - If the add to cart button was clicked from the quick view
 */
function handlePostCartAdd(response, $this, isQuickView) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else if (response.error) {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        if (isSizeSelectionError(response.message, $this.closest('.product-detail'))) {
            var shouldScroll = $('.is-sticky').length > 0 && !isQuickView;
            showPdpSizeValidationError($this.closest('.product-detail'), response.message, shouldScroll);
        } else {
            $('.add-to-cart-messages').append(
                '<div class=" alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
                + response.message
                + '</div>'
            );
        }
        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * Display add to cart modal
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {string} form - form data
 */
function handleAddToCartModal(response, form) {
    if (!response.embroideryFlow && !response.error) {
        const { pid, quantity } = form;
        const { productName, images: pImages, price: pPrice, variationAttributes, isNonMerchProduct, eGiftCardRecipient, eGiftCardSender, eGiftCardRecipientEmail, eGiftCardDeliveryDate, isSkuOnSale, isSkuOnClearance, regularPriceFormatted } = response.cart.items.find((i) => {
            return i.UUID === response.pliUUID;
        }) || { productName: '', images: { minicart: [] }, variationAttributes: [] };
        const { eGiftCardUnitPrice, eGiftCardDiscountApplied } = response.product.eGiftCard || {};
        const { url: pImage, alt: pImageAlt } = pImages.minicart[0];
        const addToCartContainer = $('.addToCartModal:first').clone();
        addToCartContainer.appendTo('body');
        const imageContainer = addToCartContainer.find('.add-to-cart-image');
        const skuContainer = addToCartContainer.find('span.product-id');
        const productNameContainer = addToCartContainer.find('div.product-name');
        const headingContainer = addToCartContainer.find('.add-to-cart-modal-heading');
        const fylContainer = addToCartContainer.find('.fyl-modal');
        const hasColorVariation = variationAttributes && variationAttributes.find((v) => v && v.attributeId === 'color');
        const hasSizeVariation = variationAttributes && variationAttributes.find((v) => v.attributeId === 'size');
        const variationAttrContainer = addToCartContainer.find('.variation-attributes');
        const quantityContainer = $(addToCartContainer.find('.product-content > .add-to-cart-attribute').toArray().find((e) => {
            return $(e).find('.label-qty').length > 0;
        }));
        const priceContainer = $(addToCartContainer.find('.product-content > .add-to-cart-attribute').toArray().find((e) => {
            return $(e).find('.label-price').length > 0;
        }));
        if (isNonMerchProduct) {
            const noneProductContent = addToCartContainer.find('.non-product-content');
            const nonProductPriceContainer = $(noneProductContent.find('.add-to-cart-attribute').toArray().find((e) => {
                return $(e).find('.label-price').length > 0;
            }));
            const qtyContainer = $(noneProductContent.find('.add-to-cart-attribute').toArray().find((e) => {
                return $(e).find('.label-qty').length > 0;
            }));
            addToCartContainer.find('.non-product-content').removeClass('d-none');
            addToCartContainer.find('.product-content').hide();
            if (!eGiftCardRecipient) {
                noneProductContent.find('.e-gift-content').hide();
            } else {
                noneProductContent.find('.sender > .value').text(eGiftCardSender);
                noneProductContent.find('.recipient > .value').text(eGiftCardRecipient);
                noneProductContent.find('.recipient-email > .value').text(eGiftCardRecipientEmail);
                const date = new Date(eGiftCardDeliveryDate);
                noneProductContent.find('.delivery-date > .value').text((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
            }
            qtyContainer.find('.value').text(quantity || 1);
            nonProductPriceContainer.find('.value').text((eGiftCardUnitPrice || pPrice.sales.formatted) + ' ' + nonProductPriceContainer.find('.value').text().trim());
            if (eGiftCardDiscountApplied) {
                nonProductPriceContainer.find('.value').addClass('sale');
                nonProductPriceContainer.find('.strike-through').removeClass('d-none').text(pPrice.sales ? pPrice.sales.formatted : regularPriceFormatted);
            }
        }

        if (isSkuOnSale) {
            priceContainer.find('.strike-through').removeClass('d-none').text(pPrice.list ? pPrice.list.formatted : regularPriceFormatted);
            priceContainer.find('.value').addClass('sale');
        } else if (isSkuOnClearance && pPrice.sales && pPrice.sales.value) {
            priceContainer.find('.value').addClass('sale');
        }
        headingContainer.text(quantity > 1 ? headingContainer.data('label1').replace('{0}', quantity) : headingContainer.data('label2').replace('{0}', quantity || 1));
        imageContainer.attr('src', pImage).attr('alt', pImageAlt);
        skuContainer.text(pid);
        productNameContainer.text(productName);
        quantityContainer.find('.value').text(quantity);

        priceContainer.find('.value').text(pPrice.sales ? pPrice.sales.formatted + ' ' + priceContainer.find('.value').text().trim() : 0);
        [hasColorVariation, hasSizeVariation].forEach((v) => {
            if (v) {
                const addToCartAttrClone = addToCartContainer.find('.add-to-cart-attribute:first').clone();
                addToCartAttrClone.find('.label').text(v.attributeId === 'size' ? variationAttrContainer.data('label-size') : v.displayName);
                addToCartAttrClone.find('.value').text(v.displayValue);
                variationAttrContainer.append(addToCartAttrClone);
            }
        });
        if (variationAttrContainer.children().length === 0) {
            variationAttrContainer.hide();
        }
        addToCartContainer.modal('show');
        addToCartContainer.one('shown.bs.modal', function () {
            addToCartContainer.find('.recommends-container').each(function () {
                $('body').trigger('widget:update', { element: this });
            });
            fylContainer.height(80).spinner().start();
            $.ajax({
                url: response.addToCartModalUrl,
                success: (addToCartHtml) => {
                    var html = $.parseHTML(addToCartHtml);
                    const fylContent = $(html).find('.fyl-wrapper');
                    fylContainer.append(fylContent);
                    carousels.addedModalProductsCarousel($('.addToCartModal.show'));
                    fyl.methods.initFYLCarousels();
                }
            }).always(() => {
                fylContainer.height('auto').spinner().stop();
                addToCartContainer.one('hidden.bs.modal', function () {
                    $('.modal-backdrop').fadeOut();
                    addToCartContainer.remove();
                });
            });
        });
    }
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * Builds the SFCC variant ID Klaviyo expects for a back-in-stock subscription.
 *
 * @param {Object} product - product passed
 * @param {string} [sizeOverride] - size from the tooltip CTA when the shopper has not selected a size
 * @returns {string} catalog variant ID (e.g. BSS362-TERAC-XXS)
 */
function getKlaviyoVariantId(product, sizeOverride) {
    if (!product) {
        return '';
    }

    var size = sizeOverride || product.selectedSize;
    if (product.isVariant && product.id) {
        if (!sizeOverride) {
            return product.id;
        }
        var idLower = String(product.id).toLowerCase();
        var sizeLower = String(sizeOverride).toLowerCase();
        if (idLower.lastIndexOf('-' + sizeLower) === idLower.length - sizeLower.length - 1) {
            return product.id;
        }
    }
    var bits = [];
    if (product.masterID) {
        bits.push(product.masterID);
    }
    if (product.selectedColor) {
        bits.push(product.selectedColor);
    }
    if (size) {
        bits.push(size);
    }
    return bits.join('-');
}

/**
 * Subscribes a shopper to Klaviyo back-in-stock via the SFCC controller.
 *
 * @param {string} emailAddress - shopper email
 * @param {string} variantId - SFCC product ID
 * @param {string} actionUrl - Klaviyo-BackInStock URL
 * @param {string} csrfToken - CSRF token
 * @returns {Promise<Object>} JSON response with success flag
 */
function subscribeKlaviyoBackInStock(emailAddress, variantId, actionUrl, csrfToken) {
    return $.ajax({
        url: actionUrl,
        method: 'POST',
        dataType: 'json',
        data: {
            email: emailAddress,
            pid: variantId,
            csrf_token: csrfToken
        }
    });
}

/**
 * Loads a CSRF token bound to the shopper's current session.
 *
 * @param {string} tokenUrl - Klaviyo-GetCSRFToken URL
 * @returns {Promise<string>} CSRF token
 */
function fetchBackInStockCsrfToken(tokenUrl) {
    return $.ajax({
        url: tokenUrl,
        method: 'GET',
        dataType: 'json',
        cache: false
    }).then(function (tokenResponse) {
        var token = tokenResponse && tokenResponse.csrf_token_value;
        if (!token) {
            throw new Error('csrf-token-missing');
        }
        return token;
    });
}

/**
 * Opens a modal to sign up the customer when the item is back in stock
 *
 * @param {Object} scope - element where the action was performed
 * @param {Object} product - product passed
 */
function handleBackInStockAlert(scope, product) {
    const form = $('#backInStockForm');
    const emailInput = form.find('#bis_email');
    const clonedForm = form.clone();
    const messages = {
        title: scope.data('success-title'),
        subtitle: scope.data('success-subtitle'),
        error: scope.data('error-message') || form.data('error-message')
    };
    const sizeOverride = scope.data('size');
    const localSkuBits = [product.masterID, product.selectedColor || '', sizeOverride || product.selectedSize];
    const variantId = getKlaviyoVariantId(product, sizeOverride);
    const isQuickView = $('#alertBackInStock').data('is-quickview');
    if (isQuickView) {
        $('#quickViewModal').modal('hide');
        $('#alertBackInStock').one('hide.bs.modal', () => {
            $('#quickViewModal').modal('show');
        });
    }
    emailInput.on('invalid', () => {
        emailInput.addClass('is-invalid').next('.invalid-feedback').hide().removeClass('d-none')
            .text(!emailInput.val().length ? form.data('nomail-message') : form.data('invalidemail-message'))
            .slideDown();
    });
    form.removeClass('d-none').one('submit', function (e) {
        e.preventDefault();
        emailInput.removeClass('is-invalid').next('.invalid-feedback').slideUp();
        var emailAddress = emailInput.val();
        var actionUrl = form.data('action');
        var tokenUrl = form.attr('data-csrf-token-url') || null;
        var $submit = form.find('button[type="submit"]:not(.invisible)');
        if (!emailAddress || !actionUrl || !variantId || !tokenUrl) {
            emailInput.addClass('is-invalid').next('.invalid-feedback').hide().removeClass('d-none')
                .text(messages.error)
                .slideDown();
            return;
        }
        $submit.prop('disabled', true);
        fetchBackInStockCsrfToken(tokenUrl)
            .then(function (csrfToken) {
                return subscribeKlaviyoBackInStock(emailAddress, variantId, actionUrl, csrfToken);
            })
            .then(function (response) {
                if (!response || !response.success) {
                    throw new Error('klaviyo-bis-failed');
                }
                updateBISAlerts(localSkuBits.join('-'));
                $('#bis_email').val('');
                form.find('div.title').text(messages.title);
                form.find('div.subtitle').text(messages.subtitle);
                $submit.fadeOut();
                form.find('button[data-dismiss="modal"]').hide().removeClass('d-none').fadeIn();
                form.find('.form-group').slideUp().fadeOut();
                $('#alertBackInStock').one('hidden.bs.modal', () => {
                    form.replaceWith(clonedForm);
                    $('body').trigger('pdpLoaded', { data: { product: $('#alertBackInStock').data('product') } });
                });
            })
            .catch(function () {
                $submit.prop('disabled', false);
                emailInput.addClass('is-invalid').next('.invalid-feedback').hide().removeClass('d-none')
                    .text(messages.error)
                    .slideDown();
            });
    });
}

/**
 * Finds the cart item matching the given product ID from cart data
 * @param {Object} cartData - Cart data object containing items array
 * @param {string} pid - Product ID to find
 * @returns {Object|null} The matching cart item or null
 */
function findCartItem(cartData, pid) {
    if (!cartData || !cartData.items) return null;
    return cartData.items.find(function (item) {
        return item.id === pid;
    }) || null;
}

/**
 * Builds Exponea cart_update event data with Bloomreach attributes
 * @param {Object} params - Event parameters
 * @param {string} params.action - Action type (add, update, remove)
 * @param {string} params.pid - Product ID (variant)
 * @param {Object} cartData - Cart data object (contains items and totals)
 * @returns {Object} Exponea event data
 */
function buildExponeaCartUpdateData(params, cartData) {
    var cartItem = findCartItem(cartData, params.pid);
    var salesPrice = 0;
    var originalPrice = 0;
    var title = '';
    var brand = '';
    var productId = params.pid ? String(params.pid).split('-')[0] : '';
    var variantId = params.pid ? String(params.pid) : '';
    var category1 = '';

    if (cartItem) {
        title = cartItem.productName || '';
        brand = cartItem.brand || '';
        category1 = cartItem.subcollection || '';
        if (cartItem.price) {
            salesPrice = cartItem.price.sales ? cartItem.price.sales.value : 0;
            originalPrice = cartItem.price.list ? cartItem.price.list.value : salesPrice;
        }
    } else if (params.removedItemData) {
        // Fallback for removed items that are no longer in the cart response
        title = params.removedItemData.productName || '';
        brand = params.removedItemData.brand || '';
        category1 = params.removedItemData.subcollection || '';
    }

    var discountValue = originalPrice - salesPrice;
    var discountPercentage = originalPrice > 0 ? Math.round((discountValue / originalPrice) * 100 * 100) / 100 : 0;

    var eventData = {
        action: params.action || '',
        product_id: productId,
        variant_id: variantId,
        title: title,
        brand: brand,
        price: salesPrice,
        original_price: originalPrice,
        discount_percentage: discountPercentage,
        discount_value: discountValue,
        category_1: category1
    };

    // Add cart-level aggregations if cart data is available
    if (cartData && cartData.items) {
        eventData.product_list = cartData.items.map(function (item) {
            return {
                product_id: item.id,
                quantity: item.quantity
            };
        });
        eventData.product_ids = cartData.items.map(function (item) {
            return item.id;
        });
        eventData.total_quantity = cartData.items.reduce(function (sum, item) {
            return sum + item.quantity;
        }, 0);
        eventData.total_price = cartData.totals && cartData.totals.subTotal
            ? parseFloat(cartData.totals.subTotal.replace(/[$,]/g, ''))
            : 0;
    }

    return eventData;
}

/**
 * Add To Cart function
 *
 * @param {jQuery} element - jQuery element that triggered the event
 * @param {Object} embroideryParams - embroidery params
 */
function addToCartFunction(element, embroideryParams) {
    var $this = $(element);
    var pid = getPidValue($this);
    var $line = $this.parents('.product-detail');
    var isQuickView = $this.parents('#quickViewModal').length > 0;
    var isProductPage = $('#pdpProductDetails').length > 0;

    if (Window.BrTrk) {
        try {
            if (typeof pid === 'string' && pid.length > 0) {
                var szBrStyle = pid.split('-')[0];
                if (pid === szBrStyle) {
                    Window.BrTrk.getTracker().logEvent('cart', 'click-add', { prod_id: pid, sku: '' });
                } else {
                    Window.BrTrk.getTracker().logEvent('cart', 'click-add', { prod_id: szBrStyle, sku: pid });
                }
            }
        } catch (error) {
            console.log('Error while sending tracking data');
        }
    }

    if (!embroideryParams) {
        var embroidery = require('org/product/embroidery');
        if (embroidery.checkEmbroiderySelection($this)) {
            embroidery.initEmbroideryModal({
                url: $this.data('url'),
                qty: $this.closest('.product-detail').find('.quantity-select', $line).val(),
                pid,
                pageContext: $this.data('pagecontext') || 'global'
            });
            return;
        }
    }

    if ($('#eGiftCardForm').length && !$('#eGiftCardForm')[0].checkValidity()) {
        return;
    }

    var addToCartUrl;
    var pidsObj;
    var setPids;

    $('body').trigger('product:beforeAddToCart', element);

    if ($('.set-items').length && $this.hasClass('add-to-cart-global')) {
        setPids = [];

        $('.product-detail').each(function () {
            if (!$this.hasClass('product-set-detail')) {
                setPids.push({
                    pid: $this.find('.product-id').text(),
                    qty: $this.find('.quantity-select').val(),
                    options: getOptions($this)
                });
            }
        });
        pidsObj = JSON.stringify(setPids);
    }

    var $productContainer = $this.closest('.product-detail');
    if (!$productContainer.length) {
        $productContainer = $this.closest('.quick-view-dialog').find('.product-detail');
    }

    addToCartUrl = getAddToCartUrl($this);
    if (isQuickView && window.location.pathname.indexOf('/cart/') > -1) {
        addToCartUrl += '?isQuickViewCart=true';
    }

    var form = {
        pid: pid,
        pidsObj: pidsObj,
        childProducts: getChildProducts(),
        quantity: getQuantitySelected($this)
    };

    var eGiftForm = $('#eGiftCardForm :input');
    if (eGiftForm.length) {
        var formData = {};
        for (let i = 0; i < eGiftForm.length; i++) {
            var el = eGiftForm[i];
            formData[el.id] = el.value;
        }
        form.eGiftForm = JSON.stringify(formData);
    }

    if (embroideryParams) {
        form.embQty = embroideryParams.embQty;
        form.components = embroideryParams.components;
        if (embroideryParams.totalQty) {
            form.quantity = embroideryParams.totalQty;
        }
    }

    if (!$('.bundle-item').length) {
        form.options = getOptions($productContainer);
    }

    $this.trigger('updateAddToCartFormData', form);
    if (addToCartUrl) {
        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                handlePostCartAdd(data, $this, isQuickView);

                // Trigger exponea cart_update event with full cart data
                if (data.cart) {
                    var eventData = buildExponeaCartUpdateData({
                        action: 'add',
                        pid: pid
                    }, data.cart);

                    $('body').trigger('exponea:updateCart', eventData);
                }
                if (isQuickView && isProductPage && !data.error) {
                    if ($('#quickViewModal').data('ref-widget-id') && pid) {
                        $('body').trigger('product:addToCartFromRecommendation', { sku: pid, itemId: String(pid).split('-')[0], refWidgetId: $('#quickViewModal').data('ref-widget-id') });
                    }
                    $('body').one('hidden.bs.modal', '#quickViewModal', function () {
                        $('#quickViewModal').remove();
                        handleAddToCartModal(data, form);
                    });
                    $('#quickViewModal').find('button.close').trigger('click');
                    if ($this.closest('.recommends-container').length && Window.BrTrk && pid) {
                        $('body').trigger('product:addToCartFromRecommendation', { sku: pid, itemId: String(pid).split('-')[0] });
                    }
                }
                // Added to Cart modal won't trigger from QV
                if (!isQuickView) {
                    handleAddToCartModal(data, form);
                }
                $('body').trigger('product:afterAddToCart', data);
                $.spinner().stop();
                miniCartReportingUrl(data.reportingURL);
                if (eGiftForm.length) {
                    if (!data.error) {
                        $('#eGiftCardForm').trigger('reset');
                        $('.quantity-module').find('.quantity-input, .quantity-select').val('1');
                    } else if (data.error) {
                        $('#eGiftCardForm')[0].checkValidity();
                    }
                }

                var giftcardItem = data.cart && data.cart.items ? data.cart.items.find(function (item) {
                    return item.isGiftCard;
                }) : null;
                if (giftcardItem) { sessionStorage.removeItem('deletedMsgShown'); }

                if (embroideryParams && embroideryParams.onSuccess) {
                    embroideryParams.onSuccess(data);
                }

                if (isQuickView && window.location.pathname.indexOf('/cart/') > -1 && data.lineItemHtml) {
                    $('ul.product-cart-item').append(data.lineItemHtml);
                    $('body').trigger('cart:updateCartTotals', data);
                }
            },
            error: function (data) {
                $.spinner().stop();

                if (embroideryParams && embroideryParams.onError) {
                    embroideryParams.onError(data);
                }
            }
        });
    }
}

/**
 * Returns a debounced version of the given function.
 * The returned function will invoke the given function after
 * the given wait time has passed since the last call.
 *
 * @param {function} func The function to debounce.
 * @param {number} wait The number of milliseconds to wait before calling the function.
 * @returns {function} The debounced function.
 */
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

// Create a debounced version of your handler
const debouncedExponeaHandler = debounce(function (event, data) {
    if (typeof exponea !== 'undefined') {
        exponea.track('cart_update', data); // eslint-disable-line no-undef
    }
}, 300); // 300ms delay, adjust as needed

$('body').on('exponea:updateCart', debouncedExponeaHandler);

/**
 * Generates the modal window on the first call.
 *
 */
function getMultiShopModalHtmlElement() {
    if ($('#shopMultipleModal').length !== 0) {
        $('#shopMultipleModal').remove();
    }
    var htmlString = `
        <div class="modal fade p-0 shop-multiple-modal" id="shopMultipleModal" tabindex="-1" role="dialog aria-labelledby="shopMultipleModalTitle">
            <div class="modal-dialog modal-dialog-fullscreen modal--added-by-js" role="document">
                <div class="modal-content">
                    <div class="modal-header pt-4">
                        <h4 class="modal-title d-block d-md-none" id="shopMultipleModalTitle">${$('[data-target="#shopMultipleModal"]').data('modal-title')}</h4>
                        <button type="button" class="close pull-right" data-dismiss="modal"></button>
                    </div>
                    <div class="modal-body d-flex flex-wrap align-content-start p-0">
                    </div>
                </div>
            </div>
        </div>
    `;
    $('body').append(htmlString);
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillMultiShopModalElement(selectedValueUrl) {
    var $smModal = $('#shopMultipleModal');
    $smModal.find('.modal-body').empty();
    $smModal.find('.modal-dialog').spinner().start();

    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            $smModal.find('.modal-body').html(data.renderedTemplate);
            var dataLength = data.multiColorSizeRows.length;
            var tableGrid = $smModal.find('.modal-body .table-grid');
            for (var i = 0; i < dataLength; i++) {
                tableGrid.append(data.multiColorSizeRows[i]);
            }
            $.spinner().stop();
            clientSideValidation.shopMultiQtyFields();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the UI on shop multiple modal quantity inputs
 *
 * @param {jQueryElement} $input jQuery element that triggered the call
 * @param {jQueryElement} currencysymbol jQuery element that triggered the call
 */
function shopMultiOnQtyChange($input, currencysymbol) {
    // Updating the row quantity
    var $parentRow = $input.parents('.color-row');
    var rowTotalQty = 0;
    var rowTotalPrice = 0;
    $parentRow.find('.js-shop-multi-qty:not([disabled])').each(function () {
        if ($(this).val() !== '') {
            rowTotalQty += parseFloat($(this).val());
            rowTotalPrice += parseFloat($(this).val()) * parseFloat($(this).data('price'));
        }
    });
    $parentRow.find('.sum-col').text(rowTotalPrice);
    $parentRow.find('.qty-col').text(rowTotalQty);
    // Updating the table total quantity
    var totalQty = 0;
    var totalPrice = 0;
    $('.table-grid').find('.qty-col').each(function () {
        if ($(this).text() !== '') {
            totalQty += parseFloat($(this).text());
        }
    });
    $('.table-grid').find('.sum-col').each(function () {
        if ($(this).text() !== '') {
            totalPrice += parseFloat($(this).text());
        }
    });
    $('.js-total-quantity').text(totalQty);
    if (totalPrice !== 0 && currencysymbol) {
        $('.js-total-price').text(currencysymbol + totalPrice.toFixed(2));
    } else if (totalPrice === 0 && currencysymbol) {
        $('.js-total-price').text(currencysymbol + totalPrice);
    }
}

/**
 * Show the particular field tooltip stock message
  * @param {element} $el - jQUery element
  * @param {string} message - string
 */
function showAlertTooltip($el, message) {
    $el.tooltip({
        title: message,
        container: '.table-wrapper',
        html: true,
        offset: '0, 20px',
        placement: 'bottom'
    }).tooltip('show');

    setTimeout(function () {
        $el.tooltip('dispose');
    }, 5000);
}

module.exports = {
    attributeSelect: attributeSelect,
    buildExponeaCartUpdateData: buildExponeaCartUpdateData,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button.color-attribute, [data-attr="color"] button.js-dropdown-color', function (e) {
            e.preventDefault();
            var $this = $(this);
            $(this).parent().spinner().start();
            // Restrict the color deselect on pdp
            if ($this.find('span.selected').length > 0) {
                $(this).parent().spinner().stop();
                return;
            }

            if ($this.attr('disabled')) {
                $(this).parent().spinner().stop();
                return;
            }
            var $productContainer = $this.closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $this.closest('.product-detail');
            }
            var qty = $(this).closest('.modal-content').find('.quantity-input').attr('value');
            attributeSelect($this.attr('data-url'), $productContainer, 'color', qty);
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $this = $(this);
            var attributeType = $this.data('attr-type');
            var $productContainer = $this.closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $this.closest('.product-detail');
            }
            attributeSelect(e.currentTarget.value, $productContainer, attributeType);
        });
    },

    initSizeTooltips: function () {
        var $sizeValue = $('.size-value:not([data-tooltip-html])');
        $sizeValue.tooltip(sizeTooltipOptions);
    },

    sizeAttribute: function () {
        $(document).on('click', '[data-attr="size"] button.size-attribute', function (e) {
            e.preventDefault();
            var $this = $(this);
            $('#alertBackInStock').data('sizeClicked', $this);
            if ($this.attr('disabled')) {
                return;
            }
            $this.parent().spinner().start();
            var $productContainer = $this.closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $this.closest('.product-detail');
            }
            clearPdpSizeValidationError($productContainer);
            var qty = $this.closest('.modal-content').find('.quantity-input').attr('value');
            let url = $this.attr('data-url');
            if (!$this.find('.selected').length) {
                // get dwvar_xxx_attr query param from data-url
                const urlObj = new URL(url);
                let sizeParamExists = false;
                // check if dwvar_xxx_size exists
                for (const param of urlObj.searchParams) {
                    if (param[0].includes('dwvar') && param[0].includes('size')) {
                        sizeParamExists = true;
                        break;
                    }
                }
                if (!sizeParamExists) {
                    let productId = '';
                    // get all query param names
                    const urlSearchParams = new URLSearchParams(urlObj.search);
                    // loop first query param name
                    for (const param of urlSearchParams) {
                        if (param[0].includes('dwvar')) {
                            // get product id safely
                            const productBits = param[0].split('_');
                            productId = productBits.length > 1 ? productBits[1] : '';
                            break;
                        }
                    }
                    urlObj.searchParams.append('dwvar_' + productId + '_size', $this.data('attr-value-id'));
                    url = urlObj.toString();
                }
                // add query param to url
            }
            attributeSelect(url, $productContainer, 'size', qty);
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer);
            }
        });
    },

    addToCart: function () {
        $(document).off('click.addToCart', 'button.add-to-cart')
            .on('click.addToCart', 'button.add-to-cart', function (event, embroideryParams) {
                event.stopPropagation();
                addToCartFunction(this, embroideryParams);
            });
    },

    addToCartQuickView: function () {
        $(document).off('click.addToCartQuickView', 'button.add-to-cart-global')
            .on('click.addToCartQuickView', 'button.add-to-cart-global', function (event, embroideryParams) {
                event.stopPropagation();
                addToCartFunction(this, embroideryParams);
            });
    },

    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                    + '<div class="selected-pid row" '
                    + 'data-pid="' + pid + '"'
                    + 'data-qty="' + submittedQty + '"'
                    + 'data-optionID="' + (optionID || '') + '"'
                    + 'data-option-selected-value="' + (valueId || '') + '"'
                    + '>'
                    + '<div class="col-sm-11 col-9 bonus-product-name" >'
                    + $choiceOfBonusProduct.find('.product-name').html()
                    + '</div>'
                    + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                    + '</div>'
                    ;
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },

    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },

    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },

    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },

    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.msgSuccess + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    globaleUpdatePrice: function () {
        // This function is initialized globaly by cart.js, don't need to call anywhere else.
        // It will only fire/require the globale Class when the country is not US, using the hidden input inside Globale own JS.
        // To convert a dynamic added price, just call `$(document.body).triggerHandler('globale:updatePrices');` anywhere.
        var globalEPriceEnabled = $('#globalePriceEnabled').length > 0;
        var PriceConverter;
        var priceConverter;

        if (globalEPriceEnabled) {
            PriceConverter = require('globalesfra/globalePriceConverter');
            priceConverter = new PriceConverter();
        }

        $(document.body).on('globale:updatePrices', function () {
            if (globalEPriceEnabled) {
                priceConverter.convertPrices();
            }
        });
    },

    alertBackInStock: function () {
        var $modal = $('#alertBackInStock');
        if (!$modal.length) {
            return;
        }
        $modal.detach().appendTo('body');
        if (!$('#backInStockForm').data('action')) {
            return;
        }
        (function initBackInStockAlert() {
            $('#alertBackInStock').data('klaviyo-enabled', true);
            let product = $('#alertBackInStock').data('product');
            $('.backInStockAlert .state-1, .backInStockAlert .state-2, .backInStockAlert .state-3').removeClass('d-none').hide();
            $('body').on('product:afterAttributeSelectInit', function (e, response) {
                product = response.data.product;
                const sizeClicked = $('#alertBackInStock').data('sizeClicked');
                $('.size-value.unselectable').removeAttr('data-tooltip-html');
                if (sizeClicked) {
                    $(sizeClicked, '.unselectable').off()
                        .attr('data-tooltip-html', true)
                        .tooltip('dispose');
                }
                $('#alertBackInStock').data('product', product);
            });
            $('body').on('product:afterAttributeSelect pdpLoaded quickview:ready', function (e, response) {
                const selectedStyleAttrs = $('#alertBackInStock div.style, #alertBackInStock div.color, #alertBackInStock div.size').removeClass('d-none').hide();
                product = response.product || response.data.product;
                if (!product || product.isNonMerchProduct) {
                    return;
                }
                if (e.type === 'quickview:ready' || $('#quickViewModal').length) {
                    if (!$('body > #alertBackInStock').length) {
                        $('.modal-body #alertBackInStock').detach().appendTo('body');
                    }
                    $('#alertBackInStock').data('is-quickview', true);
                }
                $('#alertBackInStock').data('klaviyo-enabled', true);
                const allStates = $('.backInStockAlert .state');
                allStates.filter('.d-none').hide().removeClass('d-none');
                const subscribedItems = retrieveBISAlerts();
                const sizeOOS = $('.sizes-container .size-value.unselectable');
                const sizeOOSSelections = $('.sizes-container .size-value.unselectable.selected');
                const sku = fetchSKU(product);
                const image = product && product.images && product.images.pdp && product.images.pdp[0].url;
                const productContainer = $('.backInStockAlert').closest('.product-detail');

                if (product.variationAttributes) {
                    updateAttrs(product.variationAttributes, productContainer, {});
                }

                if (sizeOOS.length && !sizeOOSSelections.length && $('.sizes-container .size-value[data-tooltip-html]').length) {
                    allStates.not('.state-1').slideUp(500);
                    $('.backInStockAlert .state-1').slideDown(500);
                } else if (product &&
                    product.isVariant &&
                    subscribedItems.includes(sku)) {
                    allStates.not('.state-3').slideUp(500);
                    $('.backInStockAlert .state-3').slideDown(500);
                    $('#alertBackInStock').find('img').attr('src', image);
                } else if (product &&
                    (product.isVariant || product.selectedSize.length) &&
                    !subscribedItems.includes(sku) &&
                    $('.sizes-container .size-value[data-tooltip-html]').length &&
                    (!product.itemStatus || product.itemStatus.toLowerCase() === 'active' || product.itemStatus.toLowerCase() === 'nobo') &&
                    (product.availability.messagesTypes.includes('notavailable') || product.availability.messagesTypes.includes('outOfStock'))) {
                    allStates.not('.state-2').slideUp(500);
                    $('.backInStockAlert .state-2').slideDown(500);
                    $('#alertBackInStock').find('img').attr('src', image);
                } else {
                    allStates.slideUp(500);
                    selectedStyleAttrs.slideUp(500);
                }
            }).trigger('pdpLoaded', { data: { product: product } });
            $(document).on('click', 'button.alert-back-in-stock, a.alert-back-in-stock', function (e) {
                const $this = $(e.currentTarget);
                const size = $this.data('size') || product.selectedSize;
                // @TODO use cookie or localstorage to track if someone already subscribed. Ask business if necessary.
                handleBackInStockAlert($(e.currentTarget), product);
                const colorAttributes = product.variationAttributes && product.variationAttributes.find(va => va.attributeId === 'color');
                let variationImg = colorAttributes && colorAttributes.values && colorAttributes.values.find(c => c.id === product.selectedColor);
                if (!variationImg) {
                    variationImg = product.images && product.images.pdp && product.images.pdp[0].url;
                } else {
                    variationImg = variationImg.images && variationImg.images.plpTile && variationImg.images.plpTile[0].url;
                }
                $('#alertBackInStock').find('img').attr('src', variationImg);
                if (product.masterID) $('#alertBackInStock div.style').show().find('strong').text(product.masterID);
                if (product.selectedColor) $('#alertBackInStock div.color').show().find('strong').text(product.selectedColor);
                if (size) $('#alertBackInStock div.size').show().find('strong').text(size);
            });
        }());
    },
    shopMultiColorsSizesEvents: function () {
        $('body').on('click', '.shop-multiple-btn', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).data('action');
            getMultiShopModalHtmlElement();
            fillMultiShopModalElement(selectedValueUrl);
        });

        $(document.body).on('blur', '#shopMultipleModal .js-shop-multi-qty', function () {
            var $this = $(this);
            var maxItems = $this.attr('max');
            var quantityEntered = $this.val();
            if (quantityEntered === '') {
                quantityEntered = 0;
            }

            if (quantityEntered >= 0) {
                if ((quantityEntered / 1) > (maxItems / 1)) {
                    $this.val('').trigger('focus');
                    showAlertTooltip($this, `Max of ${maxItems} items allowed`);
                    shopMultiOnQtyChange($this);
                } else {
                    $.spinner().start();
                    var url = $this.data('url');
                    var pid = $this.data('pid');
                    var quantity = quantityEntered;
                    var form = {
                        pid: pid,
                        quantity: quantity
                    };
                    $.ajax({
                        url: url,
                        method: 'GET',
                        data: form,
                        success: function (data) {
                            if (data.result) {
                                $this.val('').trigger('focus');
                                $.spinner().stop();
                                showAlertTooltip($this, data.message);
                                shopMultiOnQtyChange($this);
                            } else {
                                $.spinner().stop();
                                var currencysymbol = data.currencysymbol;
                                shopMultiOnQtyChange($this, currencysymbol);
                            }
                        },
                        error: function () {
                            $.spinner().stop();
                        }
                    });
                }
            } else {
                // No Ajax call will happen but need to update the UI in case the user updated the field to 0 or cleared it
                shopMultiOnQtyChange($this);
            }
        });

        $(document.body).off('submit', '#shopMultiForm').on('submit', '#shopMultiForm', function (e) {
            e.preventDefault();
            var addToCartUrl = $('#shopMultiForm').attr('action');
            var valArray = [];
            $('.table-grid td.size-col').each(function (index, ele) { // eslint-disable-line
                if ($(ele).find('.js-shop-multi-qty').val() > 0) {
                    valArray.push($(ele));
                }
            });
            var productList = [];
            for (var el = 0; el < valArray.length; el++) {
                var pid = valArray[el].find('.js-shop-multi-qty').data('pid');
                var quantity = valArray[el].find('.js-shop-multi-qty').val();
                productList.push({ pid: pid, qty: quantity });
            }
            var productListObj = JSON.stringify(productList);
            var form = { productListObj: productListObj };
            $('#shopMultipleModal').spinner().start();
            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) { // eslint-disable-line
                        $('.minicart').trigger('count:update', data);
                        var messageType = (data.error || !data.isSelected) ? 'alert-danger' : 'alert-success';
                        // show add to cart toast
                        if (data.newBonusDiscountLineItem
                            && Object.keys(data.newBonusDiscountLineItem).length !== 0) {
                            chooseBonusProducts(data.newBonusDiscountLineItem);
                        } else if (data.error || !data.isSelected) {
                            if ($('.add-to-cart-messages').length === 0) {
                                $('tbody').append('<div class="add-to-cart-messages"></div>');
                            }
                            $('.add-to-cart-messages').append(
                                '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
                                + data.message
                                + '</div>'
                            );
                            setTimeout(function () {
                                $('.add-to-basket-alert').remove();
                            }, 5000);
                        }
                        if (data && data.isSelected) {
                            $('body').trigger('product:afterAddToCart', data);
                            miniCartReportingUrl(data.reportingURL);
                            window.location.href = data.redirectUrl;
                        }
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    /**
     * Initialises all event listeners and AJAX logic for the upsell modal flow.
     * Binds open/close triggers, variant selection (color + size), length tab switching,
     * keyboard dismissal, and the confirm add-to-cart action.
     *
     * @returns {void}
     */
    addToCartUpsell: function () {
        var $modal = $('#upsellModal');
        var UPSELL_PRICE_DEBOUNCE_DELAY = 300;
        var upsellPriceDebounceTimer;

        /**
         * Resolves a formatted price string from the product response object.
         *
         * @param {Object} product - The product object from the AJAX response.
         * @returns {string} Formatted price string, or empty string if unavailable.
         */
        function resolveUpsellPriceFormatted(product) {
            if (product.pdpVariantPrice && product.pdpVariantPrice.sales && product.pdpVariantPrice.sales.formatted && product.pdpVariantPrice.sales.formatted !== 'N/A') {
                return product.pdpVariantPrice.sales.formatted;
            }
            if (product.price) {
                if (product.price.type === 'range' && product.price.min && product.price.max) {
                    return product.price.min.sales.formatted + ' - ' + product.price.max.sales.formatted;
                }
                if (product.price.sales && product.price.sales.formatted && product.price.sales.formatted !== 'N/A') {
                    return product.price.sales.formatted;
                }
            }
            return '';
        }

        /**
         * Updates the price, product ID, product link, and product image in the panel.
         *
         * @param {jQuery} $panel - The active upsell modal panel.
         * @param {Object} product - The product object from the AJAX response.
         * @returns {void}
         */
        function updateUpsellProductInfo($panel, product) {
            var formatted = resolveUpsellPriceFormatted(product);
            if (formatted) {
                $panel.find('.upsell-modal__product-price-value').text(formatted);
            }
            if (product.id) {
                $panel.find('.upsell-modal__product-number-value').text(product.id);
                $modal.data('resolved-pid', product.readyToOrder ? product.id : null);
            }
            if (product.selectedProductUrl) {
                $panel.find('.upsell-modal__product-link').attr('href', product.selectedProductUrl);
            } else {
                var $link = $panel.find('.upsell-modal__product-link');
                $link.attr('href', $link.attr('data-base-url') || '');
            }
            if (product.images && product.images.pdp && product.images.pdp[0]) {
                $panel.find('.upsell-modal__product-image').attr('src', product.images.pdp[0].url).attr('alt', product.images.pdp[0].alt || product.productName || '');
            }
        }

        /**
         * Updates the color and size option lists in the panel to reflect the
         * selected/unavailable state returned by the variation AJAX response.
         *
         * @param {jQuery} $panel - The active upsell modal panel.
         * @param {Array} variationAttributes - The variationAttributes array from the product response.
         * @returns {void}
         */
        function updateUpsellVariationAttrs($panel, variationAttributes) {
            variationAttributes.forEach(function (attr) {
                if (!attr.values || (attr.id !== 'color' && attr.id !== 'size')) { return; }
                var isColor = attr.id === 'color';
                var selectedVal = null;
                $panel.find('[data-attr="' + attr.id + '"] [data-attr-value]').hide();
                attr.values.forEach(function (val) {
                    var $opt = $panel.find('[data-attr="' + attr.id + '"] [data-attr-value="' + val.value + '"]');
                    $opt.show()
                        .toggleClass('is-selected', !!val.selected)
                        .toggleClass('is-unavailable', val.selectable === false)
                        .attr('aria-selected', val.selected ? 'true' : 'false');
                    if (val.url) { $opt.attr('data-url', val.url); } else { $opt.removeAttr('data-url'); }
                    if (val.selected) { selectedVal = val; }
                });
                if (isColor) {
                    if (selectedVal) {
                        var swatches = selectedVal.swatchColors;
                        var swatchStyle = '';
                        if (swatches && swatches.length > 1) {
                            swatchStyle = 'background: linear-gradient(to right, ' + swatches[0] + ' 70%, ' + swatches[1] + ' 0)';
                        } else if (swatches && swatches.length > 0) {
                            swatchStyle = 'background: ' + swatches[0];
                        }
                        $panel.find('.upsell-modal__color-label').text(selectedVal.displayValue);
                        $panel.find('.upsell-modal__color-trigger .upsell-modal__color-swatch').attr('style', swatchStyle);
                    } else {
                        var colorPlaceholder = $panel.find('.upsell-modal__color-trigger').data('placeholder');
                        $panel.find('.upsell-modal__color-label').text(colorPlaceholder || '');
                        $panel.find('.upsell-modal__color-trigger .upsell-modal__color-swatch').removeAttr('style').hide();
                    }
                } else if (!selectedVal) {
                    var sizePlaceholder = $panel.find('.upsell-modal__size-trigger').data('placeholder');
                    $panel.find('.upsell-modal__size-label').text(sizePlaceholder || '');
                } else {
                    $panel.find('.upsell-modal__size-label').text(selectedVal.displayValue);
                }
            });
        }

        /**
         * Updates the confirm button state and availability message based on the
         * product's readyToOrder / availability data from the variation response.
         *
         * @param {jQuery} $confirmBtn - The confirm CTA button element.
         * @param {jQuery} $availMsg - The availability message paragraph element.
         * @param {Object} product - The product object from the AJAX response.
         * @returns {void}
         */
        function updateUpsellAvailability($confirmBtn, $availMsg, product) {
            if (product.readyToOrder) {
                var messagesTypes = product.availability && product.availability.messagesTypes ? product.availability.messagesTypes : [];
                var isOutOfStock = messagesTypes.indexOf('outOfStock') > -1 || messagesTypes.indexOf('notavailable') > -1;
                var isBackOrder = messagesTypes.indexOf('backOrder') > -1;
                var shouldDisable = isOutOfStock || !product.available;

                $confirmBtn.prop('disabled', shouldDisable);
                $confirmBtn.toggleClass('disabled', shouldDisable);

                if (isOutOfStock) {
                    var outOfStockMsg = product.availability.messages && product.availability.messages.length ? product.availability.messages[0] : 'Out of Stock';
                    $availMsg.text(outOfStockMsg).removeAttr('hidden').removeClass('upsell-modal__availability-msg--backorder');
                } else if (isBackOrder) {
                    var backOrderMsg = product.availability.messages && product.availability.messages.length ? product.availability.messages[0] : '';
                    $availMsg.text(backOrderMsg).removeAttr('hidden').addClass('upsell-modal__availability-msg--backorder');
                } else if (shouldDisable && product.availability && product.availability.messages && product.availability.messages.length) {
                    $availMsg.text(product.availability.messages[0]).removeAttr('hidden').removeClass('upsell-modal__availability-msg--backorder');
                } else {
                    $availMsg.attr('hidden', true).text('');
                }
            } else {
                $confirmBtn.prop('disabled', false);
                $confirmBtn.toggleClass('disabled', false);
                $availMsg.attr('hidden', true).text('');
            }
        }

        /**
         * Fetches the price for the given Product-Variation URL and updates the
         * price display in the currently visible upsell modal panel.
         *
         * @param {string} url - A Product-Variation endpoint URL.
         * @returns {void}
         */
        function fetchUpsellPrice(url) {
            if (!url) return;
            var $panel = $modal.find('.upsell-modal__panel:not([hidden])');
            var $confirmBtn = $modal.find('.upsell-modal__confirm');
            var $availMsg = $modal.find('.upsell-modal__availability-msg');
            $confirmBtn.prop('disabled', true).addClass('disabled');
            $panel.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (data) {
                    $panel.spinner().stop();
                    $availMsg.attr('hidden', true).text('').removeClass('upsell-modal__availability-msg--backorder');
                    if (!data || !data.product) return;
                    var product = data.product;
                    updateUpsellProductInfo($panel, product);
                    if (product.variationAttributes) {
                        updateUpsellVariationAttrs($panel, product.variationAttributes);
                    }
                    updateUpsellAvailability($confirmBtn, $availMsg, product);
                },
                error: function () {
                    $panel.spinner().stop();
                    var errMsg = $availMsg.attr('data-msg-price-load') || '';
                    $modal.find('.upsell-modal__confirm').prop('disabled', true).toggleClass('disabled', true);
                    $availMsg.text(errMsg).removeAttr('hidden').removeClass('upsell-modal__availability-msg--backorder');
                }
            });
        }

        /**
         * Opens the upsell modal for the product associated with the given trigger element.
         * Reads pid, quantity, and upsell-url from the trigger's data attributes, stores
         * them on the modal, shows the matching server-rendered panel, and animates the
         * sheet into view.
         *
         * @param {jQuery} $trigger - The button element that initiated the modal open.
         * @returns {void}
         */
        function openUpsellModal($trigger) {
            var pid = $trigger.data('pid');
            $modal.data('pid', pid);
            $modal.data('quantity', $trigger.data('quantity') || 1);
            $modal.data('upsell-url', $trigger.data('upsell-url'));

            var index = $trigger.data('index');
            var $panel = $modal.find(
                index ? '.upsell-modal__panel[data-index="' + index + '"]' : '.upsell-modal__panel[data-pid="' + pid + '"]'
            );
            if (!$panel.length) { $panel = $modal.find('.upsell-modal__panel').first(); }
            $modal.find('.upsell-modal__panel').attr('hidden', true);
            $panel.removeAttr('hidden');

            var $activeTab = $panel.find('.upsell-modal__length-tab.is-active');
            if ($activeTab.length) {
                $modal.data('pid', $activeTab.data('pid'));
            }

            $modal.attr('aria-hidden', 'false');
            requestAnimationFrame(function () {
                $modal.addClass('is-open');
                var scrollY = window.scrollY || window.pageYOffset;
                $('body').addClass('upsell-modal-open').css({ position: 'fixed', top: '-' + scrollY + 'px', left: 0, right: 0 });
                $('html').css('overflow', 'hidden');
            });

            var initialUrl = $activeTab.length
                ? $activeTab.attr('data-variation-url')
                : $panel.attr('data-variation-url');
            if (initialUrl) {
                fetchUpsellPrice(initialUrl);
            } else {
                $modal.find('.upsell-modal__confirm').prop('disabled', false).removeClass('disabled');
            }
        }

        /**
         * Closes the upsell modal, reverting its open state and clearing all stored
         * product data (pid, quantity, upsell-url) from the modal element.
         *
         * @returns {void}
         */
        function closeUpsellModal() {
            $modal.find('.upsell-modal__body').removeClass('has-dropdown-open');
            $modal.find('.upsell-modal__color-trigger, .upsell-modal__size-trigger').removeClass('is-open').attr('aria-expanded', 'false');
            $modal.removeClass('is-open').attr('aria-hidden', 'true');
            var scrollY = parseInt($('body').css('top'), 10) || 0;
            $('body').removeClass('upsell-modal-open').css({ position: '', top: '', left: '', right: '' });
            $('html').css('overflow', '');
            window.scrollTo(0, -scrollY);
            $modal.removeData(['pid', 'quantity', 'upsell-url', 'resolved-pid']);
        }

        /**
         * Posts the selected upsell product to Cart-AddProduct and updates the
         * cart DOM and mini-cart on success.
         *
         * @param {string} pid - The resolved product ID to add.
         * @param {string} addToCartUrl - The Cart-AddProduct endpoint URL.
         * @param {number} quantity - The quantity to add.
         * @returns {void}
         */
        function submitUpsellToCart(pid, addToCartUrl, quantity) {
            $.spinner().start();
            var form = {
                pid: pid,
                quantity: quantity || 1,
                pview: 'tile'
            };
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    $('.minicart').trigger('count:update', data);
                    $('body').trigger('product:afterAddToCart', data);
                    if (data.upsellItemHtml) {
                        $('ul.product-cart-item').append(data.upsellItemHtml);
                        quantitySelect.updateTextField($('ul.product-cart-item li').last().find('.quantity-select'));
                        $('body').trigger('upsell:updateCartTotals', data);
                    }
                    miniCartReportingUrl(data.reportingURL, data.error);
                },
                error: function (data) {
                    if (data.responseJSON && data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    }
                },
                complete: function () {
                    $.spinner().stop();
                }
            });
        }

        $(document).on('click', '.upsell-add-to-cart[data-action="open-upsell-modal"]', function (e) {
            e.preventDefault();
            openUpsellModal($(this));
        });

        $(document).on('click', '.upsell-add-to-cart[data-action="add-to-cart-direct"]', function (e) {
            e.preventDefault();
            var $btn = $(this);
            submitUpsellToCart($btn.data('pid'), $btn.data('upsell-url'), $btn.data('quantity') || 1);
        });

        $modal.on('click', '.upsell-modal__close, .upsell-modal__backdrop', function () {
            closeUpsellModal();
        });

        ['color', 'size'].forEach(function (attrId) {
            var triggerSel = '.upsell-modal__' + attrId + '-trigger';
            var optionSel = '.upsell-modal__' + attrId + '-option';
            var dropdownSel = '.upsell-modal__' + attrId + '-dropdown';

            $modal.on('click', triggerSel, function () {
                var $t = $(this);
                var isOpen = $t.hasClass('is-open');
                $t.toggleClass('is-open', !isOpen).attr('aria-expanded', !isOpen ? 'true' : 'false');
                var $activePanel = $modal.find('.upsell-modal__panel:not([hidden])');
                var $allDropdowns = $activePanel.find('.upsell-modal__color-dropdown, .upsell-modal__size-dropdown');
                var isLast = $allDropdowns.last().hasClass('upsell-modal__' + attrId + '-dropdown');
                if (isLast) {
                    $modal.find('.upsell-modal__body').toggleClass('has-dropdown-open', !isOpen);
                }
            });

            $modal.on('click', optionSel, function () {
                var $opt = $(this);
                if ($opt.hasClass('is-unavailable') || $opt.hasClass('is-selected')) return;
                var url = $opt.attr('data-url');
                if (!url) return;
                $modal.find(triggerSel).removeClass('is-open is-error').attr('aria-expanded', 'false');
                $modal.find('.upsell-modal__' + attrId + '-dropdown').next('.upsell-modal__field-error').attr('hidden', true);
                $modal.find('.upsell-modal__body').removeClass('has-dropdown-open');
                clearTimeout(upsellPriceDebounceTimer);
                upsellPriceDebounceTimer = setTimeout(function () { fetchUpsellPrice(url); }, UPSELL_PRICE_DEBOUNCE_DELAY);
            });

            $(document).on('click.upsellDropdown' + attrId, function (e) {
                if ($modal.hasClass('is-open') && !$(e.target).closest(dropdownSel).length) {
                    $modal.find(triggerSel).removeClass('is-open').attr('aria-expanded', 'false');
                    var $activePanel = $modal.find('.upsell-modal__panel:not([hidden])');
                    var hasOpenTrigger = $activePanel.find('.upsell-modal__color-trigger.is-open, .upsell-modal__size-trigger.is-open').length > 0;
                    if (!hasOpenTrigger) {
                        $modal.find('.upsell-modal__body').removeClass('has-dropdown-open');
                    }
                }
            });
        });

        /**
         * Handles switching between length tabs (e.g. Regular, Petite, Tall).
         * Deactivates all sibling tabs and activates the clicked one, updating
         * aria-selected accordingly. Updates the modal's active pid to the
         * selected length variant's product id for add-to-cart submission.
         *
         * @listens click .upsell-modal__length-tab
         */
        $modal.on('click', '.upsell-modal__length-tab', function () {
            var $tab = $(this);
            $tab.closest('.upsell-modal__length-tabs-list')
                .find('.upsell-modal__length-tab')
                .removeClass('is-active')
                .attr('aria-selected', 'false');
            $tab.addClass('is-active').attr('aria-selected', 'true');
            var tabPid = $tab.data('pid');
            $modal.data('pid', tabPid);
            $modal.data('resolved-pid', null);

            var tabUrl = $tab.attr('data-variation-url');

            fetchUpsellPrice(tabUrl);
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $modal.hasClass('is-open')) {
                closeUpsellModal();
            }
        });

        $modal.on('click', '.upsell-modal__confirm', function () {
            var pid = $modal.data('resolved-pid') || $modal.data('pid');
            var addToCartUrl = $modal.data('upsell-url');

            if (!pid || !addToCartUrl) return;

            var $panel = $modal.find('.upsell-modal__panel:not([hidden])');
            var hasError = false;

            ['color', 'size'].forEach(function (attrId) {
                var $dropdown = $panel.find('.upsell-modal__' + attrId + '-dropdown');
                var $options = $panel.find('.upsell-modal__' + attrId + '-options');
                var $trigger = $panel.find('.upsell-modal__' + attrId + '-trigger');
                var $fieldError = $dropdown.next('.upsell-modal__field-error');
                if ($options.length && !$options.find('.is-selected').length) {
                    $trigger.addClass('is-error');
                    $fieldError.removeAttr('hidden');
                    hasError = true;
                } else {
                    $trigger.removeClass('is-error');
                    $fieldError.attr('hidden', true);
                }
            });

            if (hasError) return;

            closeUpsellModal();
            submitUpsellToCart(pid, addToCartUrl, $modal.data('quantity'));
        });
    },
    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    getOptions: getOptions,
    getAddToCartUrl: getAddToCartUrl,
    getChildProducts: getChildProducts,
    handlePostCartAdd: handlePostCartAdd,
    handleAddToCartModal: handleAddToCartModal,
    isSizeSelectionError: isSizeSelectionError,
    getSizeValidationProductDetail: getSizeValidationProductDetail,
    showPdpSizeValidationError: showPdpSizeValidationError,
    clearPdpSizeValidationError: clearPdpSizeValidationError
};
